export const STAFFS_ROUTES = {
	staffs: "/app/staffs",
} as const;
